module.exports = __webpack_public_path__ + "img/ad04.07c74b65.png";